import React from 'react';
import { EcoClub1Class2026 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub1Class2026/>;
};

export default AccountGeneralPage;